import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  AdProductsListResponse,
  ListAdProductsParams
} from "../../whatsappAdProducts.types";
import { requestGetAdProducts } from "./getAdProducts.request";

const useAdProducts = (
  requestParams: ListAdProductsParams,
  options?: QueryOptions<AdProductsListResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["whatsappAdProducts", "list", requestParams],
    queryFn: async () => await requestGetAdProducts(requestParams),
    ...options
  });

  return {
    adProducts: data?.data ?? [],
    totalItems: data?.count ?? 0,
    ...rest
  };
};

export default useAdProducts;
